import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { EditableImagePreviewHeader } from '../../../../../__legacy__/modules/datasets/components/EditableImagePreviewHeader';
import { useAttachmentsPermissions } from '../../../Attachments.permissions';
import { IRenameAttachmentBl } from '../../RenameAttachment.bl';
import { IRenameAttachmentStore } from '../../RenameAttachment.store';

interface IProps {
  name: string;
  id: string;
  parentId: string;
}

export const EditableAttachmentPreviewHeaderContainer = observer((props: IProps): ReactElement => {
  const bl = useInjection(IRenameAttachmentBl.$);
  const store = useInjection(IRenameAttachmentStore.$);
  const permissions = useAttachmentsPermissions();

  const { name, id, parentId } = props;

  const handleBlur = async (): Promise<void> => bl.renameAttachmentAsync();
  const handleNameChange = (newName: string): void => {
    bl.changeName(newName);
  };
  const handleCancel = (): void => {
    bl.changeName(name);
  };

  useEffect(() => {
    bl.initialize(id, name, parentId);
  }, [id, name, parentId]);

  const handleStartEdit = (): void => {
    bl.initialize(id, name, parentId);
  };

  return (
    <EditableImagePreviewHeader
      name={name}
      onImageNameChange={handleNameChange}
      onImageNameBlur={handleBlur}
      nameStatus={store.nameStatus}
      canRenameImages={permissions.canRenameAttachment()}
      newName={store.name}
      onCancelRenameImage={handleCancel}
      onStartEdit={handleStartEdit}
    />
  );
});
